<template>
  <div class="booking">
    <div class="container px-0">
      <div class="booking__container" v-if="loadedTabs">
        <ul class="booking__tab">
          <li
            v-for="form in enabledFormsListSorted"
            :key="form.name"
            class="booking__tabItem"
            v-show="!form.fail"
            :class="{ active: isActiveTab(form.name) }"
          >
            <a
              class="booking__tabLink"
              @click.prevent="setActiveTab(form, $event)"
              :href="'#'+form.name"
              @click="form.type === 'component' ? manageFormApp(form) : null"
            >
              <i v-if="form.icon" class="booking__tabIcon fas"  :class="form.icon"></i>
              <span class="m-0" v-html-safe="$t(form.label)"></span>
            </a>
          </li>
        </ul>
        <div class="booking__tabContent tab-content">
          <div
            v-for="form in enabledFormsListSorted"
            :key="form.name"
            :id="form.name"
            class="tab-pane fade"
            :class="{ 'active show': isActiveTab(form.name) }"
          >
            <div
              v-if="form.component && !form.embeddable"
            >
              <component
                :is="form.component"
                :bookingData="form.data"
                :scope="form.app_name"
                :baseUrl="getBaseUrl(form)"
              />
            </div>
            <div v-else>
              <iframe
                v-if="form.url"
                frameborder="0"
                class="embeddables"
                :src="getCheckinUrl()"
                :height="form.height"
                :width="form.width"
                :id="`${form.name}_iframe`"
              ></iframe>
              <!--Provisional, pero da la idea de como trabajar los formularios externos-->
            </div>
          </div>
        </div>
      </div>
      <div v-if="bookingData && bookingData.cookieMessage.enable === true">
        <cookie-message
          :buttons_enable="bookingData.cookieMessage.confirmation_button"
          @close-alert-component="closeDiv"
        ></cookie-message>
      </div>
      <div v-if="this.hasTemporaryMessage" >
        <temporary-message
          @close-alert-component="closeDiv(true)"
          :buttons_enable="bookingData.cookieMessage.confirmation_button"
          :details="bookingData.temporaryMessage.details"
        ></temporary-message>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import Searcher from 'core-lib/components/searcher/Searcher.vue'
import SearchForm from '../components/SearchForm'
import RetrieveForm from '../components/RetrieveForm'
import cookieMessage from '../components/cookieMessage'
import temporaryMessage from '../components/temporaryMessage'

export default {
  name: 'Booking',
  data () {
    return {
      bookingData: null,
      showAlert: true,
      hasTemporaryMessage: false,
      applicationsList: [],
      activeItem: null,
      loadedTabs: false
    }
  },
  computed: {
    enabledFormsListSorted () {
      let appConfig = this.forms.filter(e => {
        return this.applicationsList.includes(e.app_name)
      }).sort((a, b) => {
        return a.order - b.order
      })
      appConfig = this.addServicesTabs(appConfig)
      return appConfig
    },
    forms () {
      const forms = [
        {
          app_name: 'ecommerce',
          name: 'searchflight',
          label: 'searchflight_tab_label',
          component: 'Searcher',
          embeddable: false,
          order: 1,
          icon: this.$t('tab_icon_booking') === 'tab_icon_booking' ? null : this.$t('tab_icon_booking'),
          type: 'component'
        },
        /*
        {
          app_name: 'ecommerce',
          name: 'searchflight',
          label: 'searchflight_tab_label',
          component: 'SearchForm',
          embeddable: false,
          order: 1
        },
        */
        {
          app_name: 'webcheckin',
          name: 'webcheckin',
          label: 'retrieve_booking_web_checkin_tab_label',
          component: 'RetrieveForm',
          embeddable: false,
          order: 2,
          icon: this.$t('tab_icon_wchk') === 'tab_icon_wchk' ? null : this.$t('tab_icon_wchk'),
          type: 'component'
        },
        {
          app_name: 'manage',
          name: 'managebooking',
          label: 'retrieve_booking_manage_booking_tab_label',
          component: 'RetrieveForm',
          embeddable: false,
          order: 3,
          icon: this.$t('tab_icon_web_mmb') === 'tab_icon_web_mmb' ? null : this.$t('tab_icon_web_mmb'),
          type: 'component'
        },
        {
          app_name: 'webcheckin2',
          name: 'webcheckin2',
          label: 'webcheckin2_tab_label',
          embeddable: true,
          height: 'auto',
          width: '100%',
          // Temporal, hasta que resolvamos las propiedades de las aplicaciones como se debe
          url: 'para definir en backoffice...',
          order: 4,
          icon: null,
          type: 'embeddable'
        }
        /*,
        {
          app_name: 'insurance',
          name: 'insurance',
          label: 'travel_insurance_tab_label',
          embeddable: false,
          order: 5,
          icon: this.$t('tab_icon_insurance') === 'tab_icon_insurance' ? null : this.$t('tab_icon_insurance'),
          type: 'link'
        },
        {
          app_name: 'rental',
          name: 'rental',
          label: 'car_rental_tab_label',
          embeddable: false,
          order: 6,
          icon: this.$t('tab_icon_rental') === 'tab_icon_rental' ? null : this.$t('tab_icon_rental'),
          type: 'link'
        }
        */
      ]

      return forms
    }
  },
  components: {
    Searcher,
    SearchForm,
    RetrieveForm,
    cookieMessage,
    temporaryMessage
  },
  beforeMount () {
    this.getApplicationsList()
  },
  mounted () {
    document.querySelector('body').classList.add('--hero')
  },
  methods: {
    addServicesTabs (appConfig) {
      if (this.bookingData) {
        const widgetServicesTabs = this.bookingData.widget_services_tabs
        let order = this.forms.length + 1
        widgetServicesTabs.forEach((tab) => {
          appConfig.push({
            app_name: tab.tab_name,
            name: tab.tab_name,
            label: `tab_service_${tab.tab_name}_label`,
            embeddable: false,
            order: order,
            icon: tab.tab_icon || null,
            type: 'link',
            url: tab.tab_link
          })
          order++
        })
      }
      return appConfig
    },
    getCheckinUrl () {
      // esto es solo para emular lo que debe venir del backoffice
      var origin = window.location.origin
      var env = (
        (origin.includes('stage') ? 'stage-' : origin.includes('dev') ||
        origin.includes('qa') || origin.includes('local') ? 'qa-' : '')
      )
      return `https://wc2-${env}${this.$store.getters.getCarrier}.kiusys.net/widget/`
    },
    manageFormApp (form) {
      if (form.app_name) {
        this.$store.commit('setAppName', form.app_name)
      }
    },
    buildConfigHandlerFunction (element) {
      try {
        this[`get${this.capitalize(element.name)}Config`](element)
      } catch (e) {
        this.setLoadedTabs(element)
      }
    },
    handleFormList () {
      this.enabledFormsListSorted.map((element) => {
        if (element.order === 1) {
          this.activeItem = element.name
          this.manageFormApp(element)
        }
        if (!element.embeddable && element.component) {
          this.buildConfigHandlerFunction(element)
        }
      })
    },
    getApplicationsList () {
      this.applicationsList = this.$store.getters.getWidgetApps
      this.handleFormList()
    },
    /*
    getRetrievebookingConfig (element) {
      let baseUrl = this.getBaseUrl(element)
      axios.get(`${baseUrl}/configs/`)
        .then((response) => {
          element['data'] = response.data.response[0]
        })
        .catch((error) => {
          element['fail'] = true
          console.log('error get config backend', error)
        })
        .finally(() => {
          this.setLoadedTabs(element)
        })
    },
    */
    getSearchflightConfig (element) {
      this.$store.commit('setLoading', true)
      // axios.get(this.$store.getters.getConfigUrls.apiUrl + 'configs/')
      this.$api.searchFlights.getConfig(this.$store.getters.getConfigUrls.apiUrl)
        .then((response) => {
          const enabledRoutes = {
            information: response.data.response.simple_routes.information,
            outgoin: response.data.response.simple_routes.routes,
            return: response.data.response.simple_routes.reverse_routes
          }

          let countrySetting = response.data.response.country_settings.find(x => x.default)
          this.bookingData = {
            roundTrip: response.data.response.journey_type.round_trip,
            roundTripDefault: response.data.response.journey_type.round_trip_default,
            oneWay: response.data.response.journey_type.one_way,
            oneWayDefault: response.data.response.journey_type.one_way_default,
            passengers: response.data.response.passenger_types,
            countrySettings: response.data.response.country_settings,
            countrySetting: countrySetting,
            display_logics: response.data.response.display_logics,
            routes: response.data.response.routes,
            cabin: response.data.response.cabin,
            cookieMessage: response.data.response.privacy_policy,
            temporaryMessage: response.data.response.temporary_message,
            promo: response.data.response.promo,
            session_key: this.$store.getters.getSessionId,
            searchParameters: response.data.response.search_parameters,
            tourcodeList: response.data.response.tourcode_list,
            route_pos_assign_data: response.data.response.route_pos_assign_data,
            enabledRoutes: enabledRoutes,
            widget_services_tabs: response.data.response?.widget_services_tabs || []
          }
          element['data'] = this.bookingData
          this.setInitTemporaryMessage()
          // Norman Lo guardo para usarlo en FlightsResult
          this.$store.commit('setSearchFlightConfig', this.bookingData)
        })
        .catch((error) => {
          console.log('error get config backend', error)
          this.$router.push('internal-error')
        })
        .finally(() => {
          this.$store.commit('setLoading', false)
          this.setLoadedTabs(element)
        })
    },
    getBaseUrl (element) {
      return `${this.$store.getters.getConfigUrls.apiBaseUrl}${element.name}/api/v1`
    },
    isActiveTab (menuItem) {
      return this.activeItem === menuItem
    },
    setActiveTab (form, event) {
      if (form.type === 'component' || form.type === 'embeddable') {
        this.activeItem = form.name
      }
      if (form.type === 'link' && form.url) {
        window.open(form.url, '_blank')
      }
    },
    closeDiv (isTemporary) {
      if (isTemporary) {
        this.hasTemporaryMessage = false
      } else {
        this.bookingData.cookieMessage.enable = false
      }
    },
    setInitTemporaryMessage () {
      this.hasTemporaryMessage = this.bookingData.temporaryMessage.details.find(z => z.enable === true)
    },
    setLoadedTabs (element) {
      if (this.activeItem === element.name) {
        this.loadedTabs = true
      }
    },
    capitalize (string) {
      // esto deberia ir para algun helper
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  }
}
</script>
<style lang="sass">
body.--hero
  background-image: url("~core/assets/img/hero_bg.png")
  background-size: cover
  background-position: bottom center
.booking
  width: 100%
  padding: 1rem
  .Searcher, .retrieveForm
    border-radius: 0 0 var(--b-radius-md) var(--b-radius-md)
.booking__container
  display: flex
  flex-direction: column
  margin-bottom: 2rem
.booking__tab
  display: flex
  flex-direction: row
  font-size: var(--font-size-sm)
  color: var(--color-onSurface)
  list-style: none
  padding: 0
  margin-bottom: 0
  overflow-x: auto
.booking__tabItem
  background-color: var(--color-surface)
  display: flex
  align-items: center
  white-space: nowrap
  a
    color: var(--color-onSurface)
    &:hover
      text-decoration: none !important
      color: var(--color-onSurface)
  &:first-child
    border-radius: var(--b-radius-sm) 0 0 0
  &:last-child
    border-radius: 0 var(--b-radius-sm) 0 0
  &.active
    .booking__tabLink
      background-color: transparent
      border-bottom: 1px solid var(--color-primary)
    .booking__tabIcon
      color: var(--color-primary)
.booking__tabLink
  background-color: var(--color-overlay-05)
  padding: 0.5rem 2rem
  text-decoration: none !important
  color: var(--color-onSurface)
  cursor: pointer
  height: 100%
  width: 100%
  text-align: center
  box-sizing: border-box
  border: 1px solid var(--color-overlay-10)
  border-bottom: 0
  &:hover
    border-bottom: 1px solid var(--color-overlay-30)
    color: var(--color-onSurface)
    background-color: var(--color-overlay-10)
  &:focus
    border: 1px solid var(--color-overlay-30)
  &:active
    background-color: var(--color-overlay-20)
.tab-content > .active
  width: 100%
.booking__tabContentContainer, .booking__tabEmbeddables
  width: 100%
.booking__tabIcon
  font-size: 0.9rem
  margin-right: 0.5rem !important
.embeddables
  min-height: 450px
@media (max-width: 480px)
  .booking__tabLink
    padding: 0.5rem 1.2rem
  .booking__tabIcon
    margin-right: 0.2rem !important
@media (min-width: 768px)
  .booking
    padding-top:  3vh
@media (min-width: 992px)
  .embeddables
    display: block
    margin: 0 auto
    min-height: 200px
</style>
